<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import router from '@/router';
import { email, required, requiredIf } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'Reference | Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			userId: '',
			id: '',
			isKnowApplicant: '',
			cooperation: '',
			options: [
				{ value: 'yes', text: 'Yes' },
				{ value: 'no', text: 'No' },
				{ value: 'unsure', text: 'Unsure' },
			],
			status: [
				{ value: '1', text: 'New' },
				{ value: '2', text: 'Input Received' },
				{ value: '3', text: 'Check Completed' },
			],
			referenceToken: '',
			referencesForm: {
				user_id: '',
				user_type_id: '',
				adults_adolescents: '',
				applicant: '',
				cooperation: null,
				date: '',
				email: '',
				id: '',
				initiative: null,
				leadership: null,
				listener: null,
				maturity: null,
				congruent: null,
				name: '',
				organization: '',
				professional_boundaries: '',
				recommendation: null,
				relationship: '',
				reliability: null,
				spiritual_maturity: '',
				status: '2',
				strenths: '',
				telephone: '',
				title: '',
				token: '',
				weaknesses: '',
				year_applicant: '',
				adults_adolescents_text: '',
				professional_boundaries_text: '',
				spiritual_maturity_text: '',
			},
			typeSubmit: false,
			isDisabledToken: false,
			isDisabled: true,
			isTokenChecking: false,
		};
	},
	validations: {
		referenceToken: { required },
		referencesForm: {
			name: { required },
			adults_adolescents: { required },
			applicant: { required },
			cooperation: { required },
			date: { required },
			email: { required, email },
			initiative: { required },
			leadership: { required },
			listener: { required },
			maturity: { required },
			congruent: { required },
			organization: { required },
			professional_boundaries: { required },
			recommendation: { required },
			relationship: { required },
			reliability: { required },
			spiritual_maturity: { required },
			strenths: { required },
			telephone: { required },
			title: { required },
			weaknesses: { required },
			year_applicant: { required },
			adults_adolescents_text: {
				requiredIf: requiredIf(function () {
					return this.referencesForm.adults_adolescents === 'unsure';
				}),
			},
			professional_boundaries_text: {
				requiredIf: requiredIf(function () {
					return this.referencesForm.professional_boundaries === 'unsure';
				}),
			},
			spiritual_maturity_text: {
				requiredIf: requiredIf(function () {
					return this.referencesForm.spiritual_maturity === 'unsure';
				}),
			},
		},
	},
	methods: {
		addToken() {
			this.$v.$touch();
			this.isTokenChecking = true;

			if (this.$v.referenceToken.$error) {
				this.isTokenChecking = false;
				return;
			}

			axios
				.get('user/reference/by/token?token=' + this.referenceToken)
				.then(async (res) => {
					if (res.status == 200) {
						this.isDisabledToken = true;
						this.isDisabled = this.referencesForm.status == '3';
						this.id = res.data.response.id;
						this.referencesForm = { ...this.referencesForm, ...res.data.response };
					} else {
						await Swal.fire({
							title: 'Error!',
							text: 'Something went wrong :(',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
					this.isTokenChecking = false;
				})
				.catch(async (err) => {
					if (err.response) {
						await Swal.fire({
							title: 'Error!',
							text: err?.response?.data?.error?.message || 'Something went wrong :(',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
					this.isTokenChecking = false;
				});
		},
		addReferences() {
			this.$v.$touch();
			this.typeSubmit = true;

			if (this.$v.$invalid) {
				return;
			}

			this.referencesForm.status = '2';
			axios
				.put(`user/references/${this.id}`, this.referencesForm)
				.then((res) => {
					this.typeSubmit = false;
					if (res.status == 200) {
						Swal.fire({
							title: 'Good job!',
							text: 'Reference submitted successfully!',
							icon: 'success',
							width: 350,
							showConfirmButton: false,
							timer: 1500,
						});
						this.isDisabled = true;
						router.push({ name: 'ch_reference_thankyou' });
					}
				})
				.catch(async (err) => {
					this.typeSubmit = false;
					if (err.response) {
						await Swal.fire({
							title: 'Error!',
							text: err?.response?.data?.error?.message || 'Something went wrong :(',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
				});
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title">Please Provide Details</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a href="javascript:">Contact Us</a></p>
					</div>
				</div>
			</div>
		</div>
		<div id="create-account" class="pt-5">
			<div class="container">
				<div class="row mb-5" :class="{ 'disabled-fields': isDisabledToken || isTokenChecking }">
					<div class="col-9">
						<label class="font-size-16">Kindly insert token to fill this form <b>(You have received this via email)</b></label>
						<input v-model="referenceToken" type="text" placeholder="Enter Token" class="form-control" :class="{ 'is-invalid': $v.referenceToken.$error }" />
						<div v-if="$v.referenceToken.$error" class="invalid-feedback">
							<span v-if="!$v.referenceToken.required">Please insert token which is shared to you via email !</span>
						</div>
					</div>
					<div class="col-3 pt-2">
						<b-button type="button" @click="addToken" variant="custom">Submit Token</b-button>
					</div>
				</div>

				<form @submit.prevent="addReferences" :class="{ 'disabled-fields': isDisabled }">
					<div class="row">
						<div class="col-12 mb-5">
							<h3 class="main-title">Character Reference</h3>
						</div>

						<div class="col-12 mb-5">
							<span class="font-size-18 d-inline-block mb-2">
								Minnesota Adult & Teen Challenge offers a 12 month, faith-based, residential recovery program for adults with substance use disorder. Clients in that program are eligible to participate in MnTC’s mentor program. All mentors working with our clients must be able to model a respectable
								and stable lifestyle that is free of substance abuse. We are especially interested in the mentor’s ability to maintain professional boundaries with our clients. Because of the nature of our program, and the large amount of responsibility given to our mentors, we are requesting your
								help by completing a confidential online character reference about this applicant. Your feedback will not be revealed to the applicant, and will only take 5-10 minutes to complete.
							</span>
						</div>
					</div>

					<div class="row">
						<div class="col-12">
							<h4 class="font-size-20 mb-5 fw-bold">
								<!-- Reference -->
								Confidential Character Reference for Minnesota Adult & Teen Challenge’s Mentor Program
							</h4>
						</div>

						<div class="col-6">
							<div class="mb-3">
								<label>Your First and Last Name *</label>
								<input v-model="referencesForm.name" type="text" placeholder="Enter Name" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.name.$error }" />
								<div v-if="typeSubmit && $v.referencesForm.name.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.name.required">Your name is required</span>
								</div>
							</div>
						</div>

						<div class="col-6">
							<div class="mb-3">
								<label>Your Phone Number *</label>
								<input v-mask="'###-###-####'" v-model="referencesForm.telephone" type="text" placeholder="Enter Telephone" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.telephone.$error }" />
								<div v-if="typeSubmit && $v.referencesForm.telephone.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.telephone.required">Your phone number is required</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Your Email *</label>
								<input v-model="referencesForm.email" type="text" placeholder="Enter Email" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.email.$error }" />
								<div v-if="typeSubmit && $v.referencesForm.email.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.email.required">Your email is required</span>
									<span v-if="!$v.referencesForm.email.email">Please provide a valid email</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Relationship</label>
								<input v-model="referencesForm.relationship" type="text" placeholder="Enter Relationship" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.relationship.$error }" />
								<div v-if="typeSubmit && $v.referencesForm.relationship.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.relationship.required">Relationship is required</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Input Form Token</label>
								<input v-model="referencesForm.token" type="text" placeholder="Enter Input Form Token" class="form-control" readonly />
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Your Organization</label>
								<input v-model="referencesForm.organization" type="text" placeholder="Enter Organization" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.organization.$error }" />
								<div v-if="typeSubmit && $v.referencesForm.organization.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.organization.required">Organization is required</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Your Title *</label>
								<input v-model="referencesForm.title" type="text" placeholder="Enter Title" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.title.$error }" />
								<div v-if="typeSubmit && $v.referencesForm.title.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.title.required">Title is required</span>
								</div>
							</div>
						</div>

						<div class="col-4">
							<div class="mb-3">
								<label>Date Signed</label>
								<input v-model="referencesForm.date" type="date" class="form-control" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.date.$error }" />
								<div v-if="typeSubmit && $v.referencesForm.date.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.date.required">Date Signed is required</span>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<label class="form-check-label me-4"> How long have you known the applicant? </label>

							<div class="d-inline-flex align-items-center ms-4">
								<input id="lessthenyear" class="form-check-inline me-2" v-model="referencesForm.year_applicant" type="radio" value="lessthenyear" />
								<label for="lessthenyear" class="mb-0">Less than a Year</label>
							</div>

							<div class="d-inline-flex align-items-center ms-4">
								<input id="onetothree" class="form-check-inline me-2" v-model="referencesForm.year_applicant" type="radio" value="onetothree" />
								<label for="onetothree" class="mb-0">1 to 3</label>
							</div>

							<div class="d-inline-flex align-items-center ms-4">
								<input id="threetofive" class="form-check-inline me-2" v-model="referencesForm.year_applicant" type="radio" value="threetofive" />
								<label for="threetofive" class="mb-0">3 to 5</label>
							</div>

							<div class="d-inline-flex align-items-center ms-4">
								<input id="fivetoten" class="form-check-inline me-2" v-model="referencesForm.year_applicant" type="radio" value="fivetoten" />
								<label for="fivetoten" class="mb-0">5 to 10</label>
							</div>

							<div class="d-inline-flex align-items-center ms-4">
								<input id="tenplus" class="form-check-inline me-2" v-model="referencesForm.year_applicant" type="radio" value="tenplus" />
								<label for="tenplus" class="mb-0">10+</label>
							</div>

							<div v-if="typeSubmit && $v.referencesForm.year_applicant.$error">
								<span class="text-danger" v-if="!$v.referencesForm.year_applicant.required">This field is required</span>
							</div>
						</div>

						<div class="mb-3">
							<label>How do you know the applicant? *</label>
							<div>
								<textarea v-model="referencesForm.applicant" class="form-control" rows="3" placeholder="Write Here.." :class="{ 'is-invalid': typeSubmit && $v.referencesForm.applicant.$error }"></textarea>
								<div v-if="typeSubmit && $v.referencesForm.applicant.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.applicant.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<label>What are the applicant's strengths in regard to mentoring? *</label>
							<div>
								<textarea v-model="referencesForm.strenths" class="form-control" rows="3" placeholder="Write Here.." :class="{ 'is-invalid': typeSubmit && $v.referencesForm.strenths.$error }"></textarea>
								<div v-if="typeSubmit && $v.referencesForm.strenths.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.strenths.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<label>What are the applicant's growth areas in regard to mentoring?</label>
							<div>
								<textarea v-model="referencesForm.weaknesses" class="form-control" rows="3" placeholder="Write Here.." :class="{ 'is-invalid': typeSubmit && $v.referencesForm.weaknesses.$error }"></textarea>
								<div v-if="typeSubmit && $v.referencesForm.weaknesses.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.weaknesses.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-10">
								<label>In your opinion, is the applicant suitable for working with vulnerable adults?</label>
							</div>
							<div class="col-2">
								<b-form-select class="form-select ms-3" v-model="referencesForm.adults_adolescents" :options="options" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.adults_adolescents.$error }">
									<option slot="first" :value="null" disabled>Select Option</option>
								</b-form-select>
								<div v-if="typeSubmit && $v.referencesForm.adults_adolescents.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.adults_adolescents.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="referencesForm.adults_adolescents === 'unsure'">
							<label>please provide explanation:</label>
							<div>
								<textarea v-model="referencesForm.adults_adolescents_text" class="form-control" rows="3" placeholder="Write Here.." :class="{ 'is-invalid': typeSubmit && $v.referencesForm.adults_adolescents_text.$error }"></textarea>
								<div v-if="typeSubmit && $v.referencesForm.adults_adolescents_text.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.adults_adolescents_text.requiredIf">This field is required</span>
								</div>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-10">
								<label> In your opinion, can the applicant maintain healthy boundaries with clients? </label>
							</div>
							<div class="col-2">
								<b-form-select class="form-select ms-3" v-model="referencesForm.professional_boundaries" :options="options" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.professional_boundaries.$error }">
									<option slot="first" :value="null" disabled>Select Option</option>
								</b-form-select>
								<div v-if="typeSubmit && $v.referencesForm.professional_boundaries.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.professional_boundaries.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="referencesForm.professional_boundaries === 'unsure'">
							<label>please provide explanation:</label>
							<div>
								<textarea v-model="referencesForm.professional_boundaries_text" class="form-control" rows="3" placeholder="Write Here.." :class="{ 'is-invalid': typeSubmit && $v.referencesForm.professional_boundaries_text.$error }"></textarea>
								<div v-if="typeSubmit && $v.referencesForm.professional_boundaries_text.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.professional_boundaries_text.requiredIf">This field is required</span>
								</div>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-10">
								<label> In your opinion, does the applicant have the spiritual maturity needed to effectively model a Christian lifestyle? </label>
							</div>
							<div class="col-2">
								<b-form-select class="form-select ms-3" v-model="referencesForm.spiritual_maturity" :options="options" :class="{ 'is-invalid': typeSubmit && $v.referencesForm.spiritual_maturity.$error }">
									<option slot="first" :value="null" disabled>Select Option</option>
								</b-form-select>
								<div v-if="typeSubmit && $v.referencesForm.spiritual_maturity.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.spiritual_maturity.required">This field is required</span>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="referencesForm.spiritual_maturity === 'unsure'">
							<label>please provide explanation:</label>
							<div>
								<textarea v-model="referencesForm.spiritual_maturity_text" class="form-control" rows="3" placeholder="Write Here.." :class="{ 'is-invalid': typeSubmit && $v.referencesForm.spiritual_maturity_text.$error }"></textarea>
								<div v-if="typeSubmit && $v.referencesForm.spiritual_maturity_text.$error" class="invalid-feedback">
									<span v-if="!$v.referencesForm.spiritual_maturity_text.requiredIf">This field is required</span>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<p class="font-size-16">
								<b> Please rate the applicant for each of the following statements, on a scale of 1 to 5. (1 = least true, 5 = most true): </b>
							</p>
						</div>

						<div class="mb-3 row">
							<div class="col-5">
								<label class="mb-3">
									<!-- Cooperation : -->
									The applicant is a good communicator:
								</label>
								<div v-if="typeSubmit && $v.referencesForm.cooperation.$error">
									<span class="text-danger" v-if="!$v.referencesForm.cooperation.required">This field is required</span>
								</div>
							</div>

							<div class="col-7">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" v-model="referencesForm.cooperation" name="cooperation" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="cooperation" v-model="referencesForm.cooperation" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="cooperation" v-model="referencesForm.cooperation" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="cooperation" v-model="referencesForm.cooperation" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="cooperation" v-model="referencesForm.cooperation" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-5">
								<label class="mb-3">
									<!-- congruent : -->
									The applicant’s words and actions are congruent:
								</label>
								<div v-if="typeSubmit && $v.referencesForm.congruent.$error">
									<span class="text-danger" v-if="!$v.referencesForm.congruent.required">This field is required</span>
								</div>
							</div>

							<div class="col-7">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" v-model="referencesForm.congruent" name="congruent" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="congruent" v-model="referencesForm.congruent" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="congruent" v-model="referencesForm.congruent" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="congruent" v-model="referencesForm.congruent" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="congruent" v-model="referencesForm.congruent" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-5">
								<label class="mb-3">
									<!-- Initiative : -->
									The applicant takes initiative when action is needed:
								</label>
								<div v-if="typeSubmit && $v.referencesForm.initiative.$error">
									<span class="text-danger" v-if="!$v.referencesForm.initiative.required">This field is required</span>
								</div>
							</div>

							<div class="col-7">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="initiative" v-model="referencesForm.initiative" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-5">
								<label class="mb-3">
									<!-- Reliability : -->
									The applicant is honest and trustworthy:
								</label>
								<div v-if="typeSubmit && $v.referencesForm.reliability.$error">
									<span class="text-danger" v-if="!$v.referencesForm.reliability.required">This field is required</span>
								</div>
							</div>

							<div class="col-7">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="reliability" v-model="referencesForm.reliability" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-5">
								<label class="mb-3">
									<!-- Maturity : -->
									The applicant handles difficult situations with maturity:
								</label>
								<div v-if="typeSubmit && $v.referencesForm.maturity.$error">
									<span class="text-danger" v-if="!$v.referencesForm.maturity.required">This field is required</span>
								</div>
							</div>

							<div class="col-7">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="maturity" v-model="referencesForm.maturity" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-5">
								<label class="mb-3">
									<!-- Leadership : -->
									The applicant generally follows through on commitments:
								</label>
								<div v-if="typeSubmit && $v.referencesForm.leadership.$error">
									<span class="text-danger" v-if="!$v.referencesForm.leadership.required">This field is required</span>
								</div>
							</div>

							<div class="col-7">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="1" />
									<label class="form-check-label">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="2" />
									<label class="form-check-label">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="3" />
									<label class="form-check-label">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="4" />
									<label class="form-check-label">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="leadership" v-model="referencesForm.leadership" value="5" />
									<label class="form-check-label">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-5">
								<label class="mb-3">
									<!-- Good Listener : -->
									The applicant is a good listener:
								</label>
								<div v-if="typeSubmit && $v.referencesForm.listener.$error">
									<span class="text-danger" v-if="!$v.referencesForm.listener.required">This field is required</span>
								</div>
							</div>

							<div class="col-7">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-1" v-model="referencesForm.listener" value="1" />
									<label class="form-check-label" for="good-listener-1">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-2" v-model="referencesForm.listener" value="2" />
									<label class="form-check-label" for="good-listener-2">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-3" v-model="referencesForm.listener" value="3" />
									<label class="form-check-label" for="good-listener-3">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-4" v-model="referencesForm.listener" value="4" />
									<label class="form-check-label" for="good-listener-4">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="good_listener" id="good-listener-5" v-model="referencesForm.listener" value="5" />
									<label class="form-check-label" for="good-listener-5">5</label>
								</div>
							</div>
						</div>

						<div class="mb-3 row">
							<div class="col-5">
								<label class="mb-3">
									<!-- Overall Recommendation : -->
									Overall recommendation of the applicant as a MnTC mentor:
								</label>
								<div v-if="typeSubmit && $v.referencesForm.recommendation.$error">
									<span class="text-danger" v-if="!$v.referencesForm.recommendation.required">This field is required</span>
								</div>
							</div>

							<div class="col-7">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-1" v-model="referencesForm.recommendation" value="1" />
									<label class="form-check-label" for="recommendation-1">1</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-2" v-model="referencesForm.recommendation" value="2" />
									<label class="form-check-label" for="recommendation-2">2</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-3" v-model="referencesForm.recommendation" value="3" />
									<label class="form-check-label" for="recommendation-3">3</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-4" v-model="referencesForm.recommendation" value="4" />
									<label class="form-check-label" for="recommendation-4">4</label>
								</div>
								<div class="form-check form-check-inline ms-3">
									<input class="form-check-input" type="radio" name="recommendation" id="recommendation-5" v-model="referencesForm.recommendation" value="5" />
									<label class="form-check-label" for="recommendation-5">5</label>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-12">
							<div class="mb-4">
								<b-button type="button" @click="addReferences" variant="custom" :disabled="typeSubmit && $v.$invalid">Submit</b-button>
								<div v-if="typeSubmit && $v.$invalid" class="mt-2">
									<span class="text-danger">Please make sure all of the required fields are filled correctly.</span>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<style scoped>
.btn-custom {
	border: 0;
	border-radius: 50px;
	text-align: center;
	padding: 10px 25px;
	background-color: #c28964;
	color: #fff;
	text-transform: uppercase;
	margin-top: 18px;
	font-size: 18px;
}

.btn-custom:hover,
.btn-custom:focus {
	background-color: #7a5740;
}
</style>
